import * as AntdIcons from '@ant-design/icons';

// Shared icon mapping for toast system
export const iconMapping: Record<string, string> = {
  // HTTP Status codes
  'http200': 'CheckOutlined',
  'http201': 'CheckOutlined',
  'http204': 'CheckOutlined',
  'http301': 'ExclamationCircleOutlined',
  'http302': 'ExclamationCircleOutlined',
  'http400': 'CloseCircleOutlined',
  'http401': 'LockOutlined',
  'http403': 'StopOutlined',
  'http404': 'FileUnknownOutlined',
  'http500': 'CloseCircleOutlined',
  'http503': 'DisconnectOutlined',
  '200': 'CheckOutlined',
  '201': 'CheckOutlined',
  '204': 'CheckOutlined',
  '301': 'ExclamationCircleOutlined',
  '302': 'ExclamationCircleOutlined',
  '400': 'CloseCircleOutlined',
  '401': 'LockOutlined',
  '403': 'StopOutlined',
  '404': 'FileUnknownOutlined',
  '500': 'CloseCircleOutlined',
  '503': 'DisconnectOutlined',

  // Common terms
  'success': 'CheckOutlined',
  'error': 'CloseCircleOutlined',
  'warning': 'WarningOutlined',
  'info': 'InfoCircleOutlined',
  'alert': 'BellOutlined',
  'alarm': 'BellOutlined',

  // Equipment/Infrastructure
  'generator': 'ThunderboltOutlined',
  'power': 'ThunderboltOutlined',
  'battery': 'BatteryTwoTone',
  'network': 'ApiOutlined',
  'server': 'ServerOutlined',
  'database': 'DatabaseOutlined',
  'cloud': 'CloudOutlined',
  'storage': 'HddOutlined',

  // Operations
  'running': 'PlayCircleOutlined',
  'stopped': 'PauseCircleOutlined',
  'poweroff': 'PoweroffOutlined',
  'asleep': 'PoweroffOutlined',
  'failed': 'CloseCircleOutlined',
  'completed': 'CheckCircleOutlined',
  'pending': 'ClockCircleOutlined',
  'processing': 'LoadingOutlined',

  // Security
  'security': 'SafetyOutlined',
  'lock': 'LockOutlined',
  'unlock': 'UnlockOutlined',
  'key': 'KeyOutlined',

  // Monitoring
  'monitor': 'DashboardOutlined',
  'chart': 'LineChartOutlined',
  'report': 'FileTextOutlined',
  'log': 'FileTextOutlined',

  // Actions
  'upload': 'UploadOutlined',
  'download': 'DownloadOutlined',
  'delete': 'DeleteOutlined',
  'edit': 'EditOutlined',
  'settings': 'SettingOutlined',
  'refresh': 'ReloadOutlined',

  // Additional
  'fire': 'FireOutlined',
  'bug': 'BugOutlined',
  'thunder': 'ThunderboltOutlined',
};

// Get Ant Design icon component by name (for popup - no defaults)
export const getIconComponent = (iconName?: string) => {
  if (!iconName) return null;

  const lowerIconName = iconName.toLowerCase();
  const mappedIconName = iconMapping[lowerIconName] || iconName;
  const IconComponent = (AntdIcons as any)[mappedIconName];
  return IconComponent || null;
};

// Get Ant Design icon component with severity fallback (for banner)
export const getIconComponentWithSeverity = (iconName?: string, severity?: string) => {
  // Default icons based on severity if no custom icon provided
  if (!iconName) {
    const upperSeverity = severity?.toUpperCase() || '';
    if (upperSeverity === 'CRITICAL' || upperSeverity === 'FATAL') return AntdIcons.FireOutlined;
    if (upperSeverity === 'ERROR') return AntdIcons.CloseCircleOutlined;
    if (upperSeverity === 'WARN' || upperSeverity === 'WARNING') return AntdIcons.WarningOutlined;
    if (upperSeverity === 'ASLEEP') return AntdIcons.PoweroffOutlined;
    if (upperSeverity === 'DEBUG') return AntdIcons.BugOutlined;
    return AntdIcons.InfoCircleOutlined; // Default
  }

  const lowerIconName = iconName.toLowerCase();
  const mappedIconName = iconMapping[lowerIconName] || iconName;
  const IconComponent = (AntdIcons as any)[mappedIconName];
  return IconComponent || AntdIcons.InfoCircleOutlined;
};
